import { Typography } from "@mui/material";
import { Box } from "@mui/system";

// TODO: is it OK for the icon prop to be optional?
export function JobSection({
  keepBreaks = false,
  title,
  text,
  icon = <></>,
  className = "",
}: {
  keepBreaks?: boolean;
  title: string;
  text: string;
  icon?: JSX.Element;
  className?: string;
}) {
  return (
    <div>
      <Box className={`flex ${className} align-items-center mb-normal`}>
        {icon}
        <Typography
          variant="h2"
          style={{
            textTransform: "uppercase",
            marginLeft: "14px",
            fontSize: "24px",
            fontWeight: "600",
          }}
        >
          {title}
        </Typography>
      </Box>
      {keepBreaks ? (
        text.split("\n").map((t, i) => <Typography key={i}>{t}</Typography>)
      ) : (
        <Typography>{text}</Typography>
      )}
    </div>
  );
}
